export type CategoryLike = string | Record<string, unknown> | null | undefined;

export interface CategoryDisplay {
  label: string;
  color?: string;
}

const CANDIDATE_LABEL_KEYS = [
  'categoryLabel',
  'label',
 'name',
  'title',
  'categoryName',
  'categoryKey',
  'displayName',
] as const;

const isNonEmptyString = (value: unknown): value is string =>
  typeof value === 'string' && value.trim().length > 0;

export function resolveCategoryDisplay(category: CategoryLike): CategoryDisplay | null {
  if (isNonEmptyString(category)) {
    return { label: category.trim() };
  }

  if (category && typeof category === 'object') {
    const record = category as Record<string, unknown>;

    for (const key of CANDIDATE_LABEL_KEYS) {
      const candidate = record[key as string];
      if (isNonEmptyString(candidate)) {
        return {
          label: candidate.trim(),
          color: isNonEmptyString(record.color) ? record.color.trim() : undefined,
        };
      }
    }

    if (isNonEmptyString(record.id)) {
      return {
        label: record.id.trim(),
        color: isNonEmptyString(record.color) ? record.color.trim() : undefined,
      };
    }
  }

  return null;
}
